import { Injectable } from "@angular/core";
import { FillingFormServiceInterface } from "./filling-form.types";

@Injectable({
  providedIn: "root",
})
export class FillingFormService implements FillingFormServiceInterface {
  constructor() {}
}
